/**
 * Testing flag: append `?mobilevideoload=true` to the URL to preload every
 * lineup background video on page load and skip the mobile swap/play delays.
 */
export const isMobileVideoLoadTest = (): boolean => {
  try {
    return (
      new URLSearchParams(window.location.search).get("mobilevideoload") ===
      "true"
    );
  } catch {
    return false;
  }
};
